import Utils from '../Services/Utils';
import SelectOptions from '../Services/SelectOptions';

class FieldCondition {
  constructor(item = {}) {
    this.conditionField = item.conditionField || null;
    this.conditionType = !Utils.isNull(item.conditionType) ? item.conditionType : null;
    this.conditionValue = !Utils.isNull(item.conditionValue) ? item.conditionValue : null;
    this.errors = {};
  }

  static parse(item, fieldsIdLabelDict, fieldsIdOptionsDict) {
    const conditionFieldValue = item.condition_field || item.conditionField;
    const conditionField = !Utils.isNull(conditionFieldValue) ? (conditionFieldValue.value || conditionFieldValue) : null;
    const conditionValueValue = item.condition_value || item.conditionValue;
    let conditionValue = !Utils.isNull(conditionValueValue) ? (conditionValueValue.value || conditionValueValue) : null;
    if (Array.isArray(conditionValue)) {
      conditionValue = conditionValue.map(item => !Utils.isNull(item.value) ? item.value : item);
    }
    const conditionTypeValue = item.condition_type || item.conditionType;
    const conditionType = !Utils.isNull(conditionTypeValue) ? (conditionTypeValue.value || conditionTypeValue) : null;
    const conditionOptions = fieldsIdOptionsDict ? fieldsIdOptionsDict[conditionField] : [];
    const condition = (conditionOptions && conditionOptions.length > 0) ? SelectOptions.getValue(conditionOptions, conditionValue) : conditionValue;
    return new FieldCondition({
      conditionField: !Utils.isNull(conditionField) ? this._parseConditionField(conditionField, fieldsIdLabelDict) : null,
      conditionType: !Utils.isNull(conditionType) ? this._parseConditionType(conditionType) : null,
      conditionValue: !Utils.isNull(condition) ? condition : null,
    });
  }

  serialize() {
    let conditionValue = null;
    if (!Utils.isNull(this.conditionValue) && Array.isArray(this.conditionValue)) {
      conditionValue = this.conditionValue.map(item => item.value);
    }
    else {
      conditionValue = (Utils.isObject(this.conditionValue) ? this.conditionValue.value : this.conditionValue);
    }
    return {
      condition_field: this.conditionField.value,
      condition_type: this.conditionType.value,
      condition_value: conditionValue,
    };
  }

  static _parseConditionField(value, fieldsIdLabelDict) {
    return {
      label: fieldsIdLabelDict[value],
      value: value,
    };
  }

  static _parseConditionType(val) {
    const value = Utils.isObject(val) ? val.value : val;
    return {
      label: value.substr(0, 1).toUpperCase() + value.substr(1).toLowerCase(),
      value: value,
    };
  }

}

export default FieldCondition;